
export default {
  pma: {
    baseUrl: "https://pma.arrcencloud.net/Danzhai.PatientWebApp/",
    headers: {
      CurrentInstitutionId: "3368A58F-9A23-4AF8-B167-FB3A312894F4",
      InstitutionId: "3368A58F-9A23-4AF8-B167-FB3A312894F4"

    },
    timeout: 20000,
    ehc:false
  },
  navigation: {
    mark: "26.1932,107.788068",
    address: '贵州省黔东南苗族侗族自治州丹寨县兴泉西路延伸段南侧',
    province:"贵州省",
    city:"黔东南苗族侗族自治州",
    country:"丹寨县"
  },
  institution: {
    icon: require('../assets/images/hospital_logo.jpg'),
    hospitalNameCn: '丹寨县人民医院',
    hospitalNameEn: "",
    telephone: '0855-3611162',
  },
  rtcConfig: {
    SDKAPPID: "1400545549",
    EXPIRETIME: 604800,
    SECRETKEY: "4d71319edb7615f8e2e55988336e20b121cceed395a81a14b84882f03d30e290"
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js